<div class="container-fluid">
  <div class="row">
    <div id="search-title" class="col">
      <h1 i18n="@@upp.pointOfSale.search.title">Search Points of Sale</h1>
    </div>
  </div>
  <div class="row">
    <div class="container-fluid">
      <ama-loading-alert
        [sendingStatus]="(posDeleteSending$ | async) ?? false"
        message="Loading..."
        i18n-message="@@upp.global.messages.loading"
      >
      </ama-loading-alert>
    </div>

    <div id="search-notification" class="col">
      <ama-upp-notification
        [mainMessages]="mainMessages"
        [notification]="(getNotification() | async)!"
        (closeNotificationEvent)="closeNotification()"
      >
      </ama-upp-notification>
    </div>
  </div>
  <div class="row">
    <div id="search-criteria" class="col">
      <ama-ng-upp-pos-search-criteria
        [sendingStatus]="(posSearchSending$ | async) ?? false"
        (searchPos)="searchPosList($event)"
        (clearPos)="clearPos()"
      >
      </ama-ng-upp-pos-search-criteria>
    </div>
  </div>

  <div class="row mt-7">
    @if (!agGridTablesActivated) {
      <div class="row">
        <div id="search-result" class="col">
          <ama-ng-upp-basic-search-result-table
            [searchResults]="(getSearchResults() | async) ?? undefined"
            [selectedNames]="(selectedPosNames$ | async) ?? undefined"
            [sendingStatus]="(posDeleteSending$ | async) ?? false"
            [isLookup]="lookup"
            [lookupValues]="lookupValues"
            [lookupOptions]="lookupOptions"
            [sourceComponent]="getSourceComponent()"
            [entryType]="getEntryType()"
            [recordToSearchResult]="recordToSearchResult"
            [entryToUpdateCreator]="entryToUpdateCreator"
            [entryToUpdateNameResolver]="$any(entryToUpdateNameResolver)"
            (deleteEntry)="deletePosEntry($event)"
            (clearTableEvent)="clearPos()"
            (showDetail)="showPosDetail($event)"
            (modifyDetail)="modifyPosDetail($event)"
            (copyDetail)="copyPosDetail($event)"
            [managePermission]="managePermission"
            [displayableFields]="displayableFields"
          >
          </ama-ng-upp-basic-search-result-table>
        </div>
      </div>
    } @else {
      @if (lookup) {
        <div class="mt-3 mb-3">
          <button class="btn btn-link me-auto p-2" (click)="goBack()">
            <span class="fa-angle-left df-icon-wtd me-2"></span>
            {{ goBackLinkText }}
          </button>
        </div>
      }
      <div id="search-result" class="col">
        <div [class]="agGridTheme" class="grid-container">
          <ag-grid-angular
            [rowData]="getSearchResults() | async"
            [columnDefs]="columnDefs"
            [gridOptions]="gridOptions"
            [defaultColDef]="defaultColDef"
            (gridReady)="onGridReady($event)"
            class="grid-component"
          ></ag-grid-angular>
        </div>
      </div>
    }
  </div>
</div>
